// extracted by mini-css-extract-plugin
export default {"component":"TFMPoweredBy_component__xyVrG","link":"TFMPoweredBy_link__2NruO"};